
import React, { useContext } from 'react';
// FIX: Changed import to correct PageContext file to avoid circular dependency
import { PageContext } from '../PageContext';
import { PageContextType } from '../types';

interface BackButtonProps {
    text?: string;
    colorClass?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ text = "Back", colorClass = "text-purple-600" }) => {
    const pageContext = useContext<PageContextType | undefined>(PageContext);

    return (
        <button onClick={() => pageContext?.goBack()} className={`font-semibold flex items-center transition-opacity hover:opacity-75 ${colorClass}`}>
            <i className="ph-duotone ph-arrow-left mr-1 text-lg"></i> {text}
        </button>
    );
};

export default BackButton;
